module.exports = __webpack_public_path__ + "media/images/latest-update-5d7a438d9b8e26441763965b6cacd577.jpg";